import { CustomSessionStorage } from '@/lib/storage/customSessionStorage';

/*
  テストロジック導入メモ
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    // クエリパラメータが設定されていれば、セッションストレージに保存
    const testMode = queryParams.get('testNumberBox') == 'on' ? 'on' : 'off';
    setTestLogicMode(TEST_LOGIC_BET_CHECK_BOX, testMode);
  }, []);
*/

/* ?testNumberBox=on をクエリに設定する */

export const TEST_LOGIC_BET_CHECK_BOX = 'test-logic-bet-check-box';

export const isTestMode = (key: string) => {
  const sessionStorage = CustomSessionStorage<string>(key).get();
  if (sessionStorage == 'on') {
    return true;
  }
  return false;
};

export const setTestLogicMode = (key: string, val: 'on' | 'off') => {
  CustomSessionStorage<string>(key).set(val);
};
